module.exports = "<app-header></app-header>\r\n<router-outlet></router-outlet>\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main